import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { UserCreateForm } from "./components/UserCreateForm";

export function NewUserPage() {
  return (
    <Page title="New User">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <UserCreateForm />
      </Container>
    </Page>
  );
}
